import { Box, Input } from '@chakra-ui/react'
import * as React from 'react'
import { connectSearchBox } from 'react-instantsearch-dom'

function SearchBox({ refine }: any) {
  return (
    <form action='' role='search'>
      <Box pb={4}>
        <Input
          id='algolia_search'
          type='search'
          placeholder='Search projects'
          onChange={e => refine(e.currentTarget.value)}
        />
      </Box>
    </form>
  )
}

export default connectSearchBox(SearchBox)
